import { signal } from "@preact/signals";

// The routes on location.pathname, no router dep (spec): /projects,
// /projects/:id, /billing (served only with billing on) and /api-keys. The server never
// serves the SPA at / or the marketing site's other paths (server/site.ts).
// Anything else falls back to the projects list.

export type Route =
  | { page: "projects" }
  | { page: "workspace"; id: string }
  | { page: "billing" }
  | { page: "api-keys" };

export function parseRoute(pathname: string): Route {
  if (/^\/billing\/?$/.test(pathname)) return { page: "billing" };
  if (/^\/api-keys\/?$/.test(pathname)) return { page: "api-keys" };
  const m = pathname.match(/^\/projects\/([^/]+)\/?$/);
  if (!m?.[1]) return { page: "projects" };
  return { page: "workspace", id: decodeURIComponent(m[1]) };
}

export const route = signal<Route>(parseRoute(location.pathname));

/** `replace` swaps the current entry instead of pushing — for redirects, so Back never returns to the bad URL. */
export function navigate(path: string, opts: { replace?: boolean } = {}): void {
  if (opts.replace) history.replaceState(null, "", path);
  else history.pushState(null, "", path);
  route.value = parseRoute(path);
}

window.addEventListener("popstate", () => {
  route.value = parseRoute(location.pathname);
});
